import { useContext } from "react"
import { UserContext } from "~/context/UserContext"

export function useUser() {
  const user = useContext(UserContext)
  if (!user) throw new Error("User is not defined in context")

  return user
}
